<template>
  <div>
    <div class="index_enterprise_down">
      <a-button v-on:click="next_page" type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
    <a-carousel autoplay :autoplaySpeed="4000" arrows style="height: 100vh;" :dots="false" effect="fade">
      <template v-slot:prevArrow>
        <div class="custom-slick-arrow" style="left: 10px;z-index: 3">
          <left-circle-outlined/>
        </div>
      </template>
      <template v-slot:nextArrow>
        <div class="custom-slick-arrow" style="right: 10px;z-index: 3">
          <right-circle-outlined/>
        </div>
      </template>
      <div v-for="(item, index) in enterprise.items" :key="index">
        <a-row>
          <a-col :span="12" style="height: 100vh">
            <div class="index_enterprise_introduction">
              <div style="padding-top: 30vh;padding-left: 10vw;padding-right: 5vw; text-align: left">
                <p style="font-size: 36px;margin-bottom: 1vh">被投企业</p>
                <p>————</p>
                <p style="font-size: 25px;margin-bottom: 2vh">{{ item.name }}</p>
                <p style="font-size: 14px">{{ item.introduction }}</p>
              </div>
            </div>
          </a-col>
          <a-col :span="12" style="height: 100vh">
            <div class="index_enterprise_owner index_enterprise_introduction" >
              <img :src="item.picture_owner">
              <div class="index_enterprise_owner_text">
                <p style="font-size: 25px; padding-top: 8vh">{{ item.name }}</p>
                <p style="font-size: 22px">{{ item.owner }}</p>
                <p>——</p>
                <br>
                <a-button type="ghost" style="margin-top: 10vh">
                  <router-link :to="'/enterprise'" @click.passive="backtotop">查看更多被投企业</router-link>
                </a-button>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-carousel>
  </div>
</template>

<script>
import {reactive, onMounted} from 'vue'
import axios from "axios";
import {DownOutlined, LeftCircleOutlined, RightCircleOutlined} from "@ant-design/icons-vue/";


export default {
  name: 'Index_enterprise',
  components: {DownOutlined, LeftCircleOutlined, RightCircleOutlined},
  setup() {
    const enterprise = reactive({
      items: []
    })
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    onMounted(() => {   //调用展示于首页的企业信息
      axios.get('https://sig-china.com:8081/api/enterprise/index/')
          .then((res) => {
            for (let i = 0; i < res.data.length; i++) {  //抓取所有数据
              enterprise.items.push(res.data[i])
            }
            for (let i = 0; i < enterprise.items.length; i++) {  //给图片资源添加前缀
              enterprise.items[i]["trademark"] = 'https://sig-china.com' + enterprise.items[i]["trademark"]
              enterprise.items[i]["picture_owner"] = 'https://sig-china.com' + enterprise.items[i]["picture_owner"]
              enterprise.items[i]['introduction'] = enterprise.items[i]["introduction"].replace(/\r\n/g, "\r\n\r\n")
            }
          })


    })
    const backtotop = () => {  //回到头部位置
      document.documentElement.scrollTo(0, 0)
    }
    return {enterprise, next_page, backtotop}

  }
}

</script>
<style scoped>
/*有跑马灯组件需要使用scoped-*/
.ant-carousel ::v-deep(.slick-slide) {
  height: 100vh;
}

img {
  width: 50vw;
  height: 90vh;
  filter: brightness(80%);
  margin-top: 10vh;
  object-fit: cover;
}

.ant-carousel ::v-deep(.slick-slide .index_enterprise_introduction) {
  background-image: url("../../../assets/background/index_enterprise.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.ant-carousel ::v-deep(.slick-slide .index_enterprise_owner) {

  height: 90vh;
  display: flex;
}

.ant-carousel ::v-deep(.slick-slide .index_enterprise_owner_text) {
  position: absolute;
  z-index: 2;
  text-align: left;
  padding-top: 30vh;
  padding-left: 5vh;
}

.index_enterprise_down {
  height: 8vh;
  padding-top: 88vh;
  position: absolute;
  z-index: 2;
  padding-left: calc(50vw - 27px);
}

.ant-carousel ::v-deep(.slick-arrow.custom-slick-arrow) {
  width: 10vh;
  height: 10vh;
  font-size: 10vh;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
  margin: 0 1vw;
}

.ant-carousel ::v-deep(.custom-slick-arrow:before) {
  display: none;
}

.ant-carousel ::v-deep(.custom-slick-arrow:hover) {
  opacity: 0.5;
}
</style>
